module.exports = __webpack_public_path__ + "img/img_29_1.0bad0e89.png";